import { useTranslation } from 'react-i18next';
import { ThemedPanel } from '../ui/ThemedSurface';
import { EPHUB_COLORS as C } from '@/constants';

/** Locked state when user is below A3 for EP hall. */
export function EpTradeLevelGate() {
  const { t } = useTranslation();

  return (
    <ThemedPanel className="p-5 text-center" theme={C}>
      <div className="text-sm font-semibold" style={{ color: C.text }}>
        {t('epHub.levelRequiredTitle', '需 A3 及以上级别')}
      </div>
      <p className="mt-2 text-xs leading-relaxed" style={{ color: C.muted }}>
        {t(
          'epHub.levelRequired',
          'EP 交易大厅仅对 A3 及以上服务级别开放，达到级别后可查看挂单并购买。',
        )}
      </p>
    </ThemedPanel>
  );
}
